import React, { useEffect, useState, useCallback } from "react";
import { getEmployeePayoutReport } from "../../api";
import api from "../../api";

export default function EmployeePayoutReport() {

  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    employee_name: "",
    customer: "",
    search: ""
  });

  const downloadExcel = async () => {
    try {
      const response = await api.get("/reports/export-employee-payout", {
        params: filters,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "employee_payout.csv");
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error(err);
      alert("Download failed");
    }
  };

  const fetchData = useCallback(async () => {
    const res = await getEmployeePayoutReport(filters);
    setRows(res.data || []);
  }, [filters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const totalPayout = rows.reduce(
    (s, r) => s + Number(r.individual_payout || 0),
    0
  );

  return (
    <div className="container-fluid mt-3 px-2">

      <h4 className="mb-3">👷 Employee Payout Report</h4>

      {/* FILTERS */}
      <div className="card p-3 mb-3">
        <div className="row g-2">

          <div className="col-6 col-md-2">
            <input type="date" className="form-control"
              onChange={(e)=>setFilters({...filters, from_date:e.target.value})}/>
          </div>

          <div className="col-6 col-md-2">
            <input type="date" className="form-control"
              onChange={(e)=>setFilters({...filters, to_date:e.target.value})}/>
          </div>

          <div className="col-12 col-md-2">
            <input placeholder="Employee" className="form-control"
              onChange={(e)=>setFilters({...filters, employee_name:e.target.value})}/>
          </div>

          <div className="col-12 col-md-2">
            <input placeholder="Customer" className="form-control"
              onChange={(e)=>setFilters({...filters, customer:e.target.value})}/>
          </div>

          <div className="col-12 col-md-2">
            <input placeholder="Search..." className="form-control"
              onChange={(e)=>setFilters({...filters, search:e.target.value})}/>
          </div>

          <div className="col-12 col-md-2 d-flex gap-2">
            <button className="btn btn-primary w-50" onClick={fetchData}>
              Apply
            </button>
            <button className="btn btn-success w-50" onClick={downloadExcel}>
              Excel
            </button>
          </div>

        </div>
      </div>

      {/* SUMMARY */}
      <div className="row mb-3">
        <div className="col-12 col-md-4">
          <div className="card p-2 text-center">
            👷 Total Payout <br />
            <b>$ {totalPayout.toFixed(2)}</b>
          </div>
        </div>
      </div>

      {/* DESKTOP TABLE */}
      <div className="table-responsive d-none d-md-block">
        <table className="table table-bordered table-hover table-sm">
          <thead className="table-light">
            <tr>
              <th>Employee</th>
              <th>Ticket</th>
              <th>Date</th>
              <th>Hours</th>
              <th>Product</th>
              <th>Door</th>
              <th>Carrier</th>
              <th>Vendor</th>
              <th>Customer</th>
              <th>Cases</th>
              <th className="d-none d-md-table-cell">Sorts</th>
              <th className="d-none d-md-table-cell">Weight</th>
              <th>Billable</th>
              <th>Total Payout</th>
              <th>Individual</th>
              <th>Work %</th>
              <th className="d-none d-md-table-cell">Margin</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td>{r.employee}</td>
                <td>{r.ticket}</td>
                <td>{r.date}</td>
                <td>{r.total_hours}</td>
                <td>{r.product_type || "—"}</td>
                <td>{r.door || "—"}</td>
                <td>{r.carrier || "—"}</td>
                <td>{r.vendor || "—"}</td>
                <td>{r.customer}</td>
                <td>{r.cases}</td>
                <td className="d-none d-md-table-cell">{r.sorts}</td>
                <td className="d-none d-md-table-cell">{r.weight}</td>
                <td>$ {r.price}</td>
                <td>$ {r.total_payout}</td>
                <td>$ {r.individual_payout}</td>
                <td>
                  <span className="badge bg-info">
                    {r.work_percentage}%
                  </span>
                </td>
                <td className="d-none d-md-table-cell">
                  <span className="badge bg-success">
                    $ {r.margin}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MOBILE CARD VIEW */}
      <div className="d-md-none">
        {rows.map((r, i) => (
          <div key={i} className="card mb-2 p-2 shadow-sm">

            <div className="d-flex justify-content-between">
              <strong>{r.employee}</strong>
              <span className="badge bg-info">
                {r.work_percentage}%
              </span>
            </div>

            <div className="small text-muted">
              Ticket #{r.ticket} • {r.date}
            </div>

            <div>
            <b>Hours:</b> {r.total_hours}
            </div>

            <div className="mt-1">
              <b>Product:</b> {r.product_type || "—"}
            </div>

            <div>
            <b>Door:</b> {r.door || "—"}
            </div>

            <div>
            <b>Carrier:</b> {r.carrier || "—"}
            </div>

            <div>
              <b>Vendor:</b> {r.vendor || "—"}
            </div>

          <div>
            <b>Customer:</b> {r.customer}
          </div>

            <div className="d-flex justify-content-between mt-2">
              <span>Cases: {r.cases}</span>
              <span>Sorts: {r.sorts}</span>
            </div>

            <div className="d-flex justify-content-between">
              <span>$ {r.price}</span>
              <span className="text-success">
                $ {r.individual_payout}
              </span>
            </div>

          </div>
        ))}
      </div>

    </div>
  );
}